export default __webpack_public_path__ + "static/media/Montserrat-SemiBold.04af9a9e.ttf";